exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-card[data-v-f3e585ae] {\n  font-size: 20px;\n  font-weight: bold;\n}\n.payment.card .content.MOBILEPAY.active[data-v-f3e585ae], .payment.card .content.VIPPS.active[data-v-f3e585ae] {\n  background-color: #f8f8f8;\n  border-top: 1px solid #ccc !important;\n  border-radius: 10px !important;\n}\n.payment.card .content.MOBILEPAY.active img[data-v-f3e585ae], .payment.card .content.VIPPS.active img[data-v-f3e585ae] {\n  height: auto;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f3e585ae","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/payment/Card.vue
// module id = 9d7l
// module chunks = 1